(() => {
  "use strict";

  const DATA_SECTION_TYPE = "data-section-type";
  const PRODUCT_SELECTOR = `[${DATA_SECTION_TYPE}="product"]`;
  const MEASUREMENTS_SELECTOR = "[data-variant-measurements]";
  const ROW_SELECTOR = "[data-variant-measurements-row]";

  const initContainer = (container) => {
    const target = container.querySelector(MEASUREMENTS_SELECTOR);
    if (!target) return;

    const sectionId = target.getAttribute("data-variant-measurements-section");
    if (!sectionId) return;

    const jsonEl = container.querySelector(`#VariantMeasurements-${sectionId}`);
    if (!jsonEl || !jsonEl.textContent) return;

    let measurementsByVariant;
    try {
      measurementsByVariant = JSON.parse(jsonEl.textContent);
    } catch {
      return;
    }

    const row = target.closest(ROW_SELECTOR) || target.parentElement;

    const updateForVariant = (variant) => {
      if (!variant || !variant.id) return;

      const value = measurementsByVariant[String(variant.id)];

      if (typeof value === "string" && value.trim() !== "") {
        target.innerHTML = value.split("\n").join("<br>");
        if (row) row.style.display = "";
      } else {
        target.innerHTML = "";
        if (row) row.style.display = "none";
      }
    };

    container.addEventListener("theme:variant:change", (event) => {
      const variant = event.detail && event.detail.variant;
      updateForVariant(variant);
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    const containers = document.querySelectorAll(PRODUCT_SELECTOR);
    if (!containers.length) return;

    containers.forEach(initContainer);
  });
})();